<template>
  <v-textarea
    v-model="localValue"
    class="mt-4"
    :rules="rules"
    :counter="counter"
    :label="title"
    :clearable="clearable"
    :readonly="readOnly"
    outlined
  />
</template>

<script>
import { mixinFormItemGeneric } from '../mixins/mixin-form-item-generic'

export default {
  mixins: [mixinFormItemGeneric],
}
</script>
